// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import Http from './service/http'
import globalData from './service/globalData'

Vue.config.productionTip = false

Vue.use(ViewUI);

Vue.prototype.$http = Http.Http;
Vue.prototype.$session = Http.sskey;
Vue.prototype.$globalData = globalData;

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js